import { render } from "./RestrictionDetailEdit.vue?vue&type=template&id=6d9af02e&scoped=true"
import script from "./RestrictionDetailEdit.vue?vue&type=script&lang=js"
export * from "./RestrictionDetailEdit.vue?vue&type=script&lang=js"

import "./RestrictionDetailEdit.vue?vue&type=style&index=0&id=6d9af02e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9af02e"]])

export default __exports__